export const getArticleCta = (type) => {
  if (!type) {
    return 'Read More';
  }
  let label;
  switch (type.toLowerCase()) {
    case 'whitepaper':
      label = 'Read the Whitepaper';
      break;
    case 'guide':
      label = 'Read the Guide';
      break;
    case 'video':
      label = 'Watch the Video';
      break;
    case 'report':
      label = 'Read the Report';
      break;
    default:
      label = 'Read More';
      break;
  }
  return label;
};

export const getThemeClass = (themeName) => {
  if (!themeName) return '';
  return `theme-${themeName
    .toLowerCase()
    .replace(/\s+/g, '-')
    .replace(/[^a-z0-9-]/g, '')}`.trim();
};

export const isLocalLink = (url) =>
  url && (url.indexOf('fullstory.com') > -1 || url.indexOf('fullstorypreview.com') > -1 || url.indexOf('/') === 0);

// Takes a start date and event length (in days) to return a date range that accommodates events spanning months and even years
export const formatDateRange = (start, length, showYear = true) => {
  const startDate = new Date(start);
  const endDate = new Date(start);
  endDate.setDate(endDate.getDate() + length - 1);
  const sameMonth = startDate.getMonth() === endDate.getMonth();
  const sameYear = startDate.getYear() === endDate.getYear();

  if (sameYear) {
    if (sameMonth) {
      const format = { month: 'long', day: 'numeric' };
      const month = startDate.toLocaleDateString('en-US', { month: 'long' });
      const first = startDate.toLocaleDateString('en-US', format);
      const last = endDate
        .toLocaleDateString('en-US', showYear ? { ...format, year: 'numeric' } : format)
        .replace(month, '');
      return `${first} – ${last}`;
    } else {
      const format = { month: 'short', day: 'numeric' };
      const first = startDate.toLocaleDateString('en-US', format);
      const last = endDate.toLocaleDateString('en-US', showYear ? { ...format, year: 'numeric' } : format);
      return `${first} – ${last}`;
    }
  } else {
    const format = { month: 'short', day: 'numeric', year: 'numeric' };
    const first = startDate.toLocaleDateString('en-US', format);
    const last = endDate.toLocaleDateString('en-US', format);
    return `${first} – ${last}`;
  }
};

export const addTrailingSlash = (slug) => {
  if (!slug) return null;
  if (slug.includes('http')) return slug;
  return slug[slug.length - 1] === '/' ? slug : slug + '/';
};

// Remove http:// or https://, www., and anything following a slash at the end
export const cleanUrl = (url) => {
  url = url.replace(/^https?:\/\//, '');
  url = url.replace(/^www\./, '');
  url = url.split('/')[0];
  return url;
};

export function mergeUrlParams(productUrl, searchQuery) {
  if (typeof window === 'undefined' || !productUrl || !searchQuery) return productUrl;
  const base = new URL(productUrl, window.location.origin);
  const baseParams = base.searchParams;
  const incomingParams = new URLSearchParams(searchQuery);

  for (const [key, value] of incomingParams.entries()) {
    if (key !== 'fs_product') {
      baseParams.set(key, value);
    }
  }
  return `${base.pathname}?${baseParams.toString()}`;
}
